import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { ROUTES } from "~/router";
import { Title, usePageTitle } from "~/shared";
import { useBookingFlowStore, usePatientStore } from "~/stores";
import { customIcons, icons } from "~/ui";
import HighlightedText from "~/ui/common/HighlightedText";
import { VisitCard } from "./components";

const cardsData = [
  {
    title: "Meet with a clinician",
    description: "Available in select states.",
    type: "clinician",
    icon: (
      <customIcons.Clinic className="text-violet size-8" aria-hidden="true" />
    ),
    route: ROUTES.hubMeetClinician,
  },
  {
    title: "Meet with a coach",
    description: "Available in all states.",
    type: "coach",
    icon: (
      <customIcons.Community
        className="text-violet size-8"
        aria-hidden="true"
      />
    ),
    route: ROUTES.hubMeetCoach,
  },
];

export const BookVisit = () => {
  usePageTitle("Book a Visit");
  const clearBookingFlow = useBookingFlowStore((state) => state.clear);
  const setIsRescheduling = usePatientStore((state) => state.setIsRescheduling);

  useEffect(() => {
    clearBookingFlow();
    setIsRescheduling(false);
  }, []);

  return (
    <section className="space-y-8">
      <Title>
        Book a <HighlightedText>Visit</HighlightedText>
      </Title>
      <div className="space-y-4">
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8">
          {cardsData.map((card) => (
            <VisitCard.Root to={card.route} key={card.type}>
              <div className="flex w-full flex-row items-center gap-4">
                <VisitCard.Icon>{card.icon}</VisitCard.Icon>

                <div>
                  <VisitCard.Title>{card.title}</VisitCard.Title>

                  <VisitCard.Description>
                    {card.description}
                  </VisitCard.Description>
                </div>
              </div>
              <VisitCard.Arrow />
            </VisitCard.Root>
          ))}
        </section>

        <section>
          <Link
            to={ROUTES.hubMoreInformation}
            className="text-violet hover:text-violet flex items-center gap-1 text-sm md:text-base"
          >
            More information
            <icons.outline.ChevronRightIcon className="text-violet size-4 stroke-2" />
          </Link>
        </section>
      </div>
    </section>
  );
};
